/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar15 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar15", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M12.555,21.543 h-1.793v-5.43H10.67l-1.699,1.147v-1.543l1.791-1.221h1.793V21.543z M18.262,21.734c-1.637,0-2.73-0.962-2.754-2.241h1.625 c0.084,0.518,0.553,0.859,1.143,0.859c0.654,0,1.119-0.449,1.119-1.138c0-0.703-0.469-1.172-1.123-1.172 c-0.498,0-0.85,0.225-1.074,0.581h-1.578l0.332-4.126h4.688v1.396h-3.305l-0.133,1.636h0.094c0.273-0.439,0.771-0.723,1.494-0.723 c1.338,0,2.295,0.991,2.295,2.363C21.084,20.694,19.961,21.734,18.262,21.734z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar15.defaultProps = {
  className: null
};

IconCalendar15.propTypes = {
  className: PropTypes.string
};

export default IconCalendar15;
